"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RenderToRoot_1 = __importDefault(require("components/RenderToRoot"));
const TopCardsTable_1 = __importDefault(require("components/TopCardsTable"));
const FilterContext_1 = require("contexts/FilterContext");
const MainLayout_1 = __importDefault(require("layouts/MainLayout"));
const TopCardsPage = ({ loginCallback = '/' }) => (react_1.default.createElement(FilterContext_1.FilterContextProvider, null,
    react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
        react_1.default.createElement(TopCardsTable_1.default, null))));
exports.default = (0, RenderToRoot_1.default)(TopCardsPage);
